import React from "react";
import { createRoot } from "react-dom/client";
import EmpireClient from "./EmpireClient";

const el = document.getElementById("empire-root");
if (el) {
  createRoot(el).render(
    <React.StrictMode>
      <EmpireClient />
    </React.StrictMode>
  );
}
